import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import CreateAcuDeviceProvider from "./baseProviders/createAcuDeviceProvider"
import useStartNewAcuDeviceVersion from "../../../../../services/middleware/hooks/devices/lct/useStartNewAcuDeviceVersion"

interface INewAcuDeviceVersionFormUrlParams {
    deviceRef: string
}

interface INewAcuDeviceVersionProviderProps {
    children: ReactNode
}

const NewAcuDeviceVersionProvider = ({
    children,
}: INewAcuDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewAcuDeviceVersionFormUrlParams
    >() as INewAcuDeviceVersionFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newAcuDeviceVersionError,
        apiResSystemRef: systemReference,
    } = useStartNewAcuDeviceVersion(urlDeviceRef, attachmentUUID)

    return (
        <CreateAcuDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newAcuDeviceVersionError}
            attachmentUUID={attachmentUUID}
            systemReference={systemReference ?? ""}
            canEditManufacturer={false}
        >
            {children}
        </CreateAcuDeviceProvider>
    )
}

export default NewAcuDeviceVersionProvider
